import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconOdometer = (props) => (
  <SvgIcon
    {...props}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.6372 7.179L12.6471 8.0364C11.96 7.37032 11.1199 6.86434 10.186 6.57816L10.5663 5.32209C11.7386 5.68198 12.7887 6.32797 13.6372 7.179ZM14.2162 7.83063L13.2289 8.68565C13.7958 9.41542 14.2044 10.1889 14.4012 11.1281L15.7246 11.2156C15.508 9.95131 14.977 8.79448 14.2162 7.83063ZM9.33869 6.38397L9.72223 5.11718C8.26064 4.85722 6.82192 5.03708 5.54081 5.58426L6.08325 6.77873C7.10165 6.36383 8.16938 6.21597 9.33869 6.38397ZM10.4472 19.709L9.87679 18.5032C6.49128 19.3498 2.64394 17.1195 2.29968 12.8251L1 12.855C1.41336 18.5796 6.76898 20.8642 10.4472 19.709ZM2.31549 11.9491C2.49338 9.91398 3.65096 8.15905 5.30753 7.16984L4.7632 5.9712C2.65344 7.18008 1.18455 9.40266 1.00945 11.979L2.31549 11.9491ZM10.1328 13.5793L23 12.5725V12.2223L9.95946 11.3032C10.4673 11.961 10.4617 12.7339 10.1328 13.5793L10.1328 13.5793ZM9.74285 12.3975C9.74285 11.4574 8.72879 10.8668 7.92184 11.3368C7.11497 11.8068 7.11497 12.9881 7.92184 13.4581C8.72879 13.9281 9.74285 13.3374 9.74285 12.3975Z" fill="currentColor" />
  </SvgIcon>
);

export default IconOdometer;
